type Environment = "development" | "test" | "production";

interface Config {
  baseUrl: string;
  url: string;
  domain: string;
  sourceUrl: string;
}

const config: Record<Environment, Config> = {
  development: {
    baseUrl:
        process.env.NEXT_APP_DEVELOPMENT_BASE_URL || "http://api.griffin.local/",
    url: process.env.NEXT_APP_DEVELOPMENT_URL || "http://localhost:3000/",
    domain:
        process.env.NEXT_APP_DEVELOPMENT_DOMAIN_IMAGE || "static.elanzacom.ir",
    sourceUrl: process.env.NEXT_APP_DEVELOPMENT_URL || "http://localhost:3000/",
  },
  test: {
    baseUrl: process.env.NEXT_APP_TEST_BASE_URL || "https://api.elanzacom.ir/",
    url: process.env.NEXT_APP_TEST_URL || "https://new.elanzacom.ir/",
    domain: process.env.NEXT_APP_TEST_DOMAIN_IMAGE || "static.elanzacom.ir",
    sourceUrl: process.env.NEXT_APP_TEST_URL || "https://new.elanzacom.ir/",
  },
  production: {
    baseUrl:
        process.env.NEXT_APP_PRODUCTION_BASE_URL || "https://api.elanza.com/",
    url: process.env.NEXT_APP_PRODUCTION_URL || "https://elanza.com/",
    domain: process.env.NEXT_APP_PRODUCTION_DOMAIN_IMAGE || "static.elanza.com",
    sourceUrl: process.env.NEXT_APP_PRODUCTION_URL || "https://elanza.com",
  },
};

const environment =
    (process.env.NEXT_APP_MODE as Environment) ?? process.env.Next_app_mode;
export default config[environment];
